import React from 'react';

import { IBudget } from 'modules/checkout/domain/entities';
import { PageTitle } from 'modules/checkout/presentation/components/atoms';
import { PreCheckoutProgress } from 'modules/checkout/presentation/components/molecules';
import { Button } from 'shared/presentation/components/molecules';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';
import PackagesAccordion from '../PackagesAccordion';

interface IBudgetSummaryProps {
  budget: IBudget;
  onContinue(): void;
  showProgress?: boolean;
}

const BudgetSummary: React.FC<IBudgetSummaryProps> = ({
  budget,
  onContinue,
  showProgress = true,
}) => {
  const { t } = useLocale('checkout');
  const isMobile = useMediaQuery('md');

  const isTheCustomerMinor = budget.customer.minorityStatus !== 'ADULT';
  const serviceTaker = budget.customer.guardian || budget.customer;

  return (
    <S.Container>
      <main>
        {showProgress && <PreCheckoutProgress currentStep="BUDGET_SUMMARY" />}

        <PageTitle
          title={t('Hello {{name}}!', { name: budget.customer.firstName })}
          subtitle={
            isMobile
              ? t(
                  'Please, verify the information about your budget below to continue',
                )
              : t(
                  'We are very happy that you are on this journey with us! Please, verify the information about your budget below to continue',
                )
          }
        />

        <S.DataSection>
          <h3>
            {isTheCustomerMinor
              ? t('Legal guardian data')
              : t('Service taker data')}
          </h3>

          <div>
            <div className="row">
              <div className="item">
                <strong>{t('Name')}</strong>
                <span>
                  {serviceTaker.firstName} {serviceTaker.lastName}
                </span>
              </div>

              <div className="item">
                <strong>{t('Document')}</strong>
                <span>{serviceTaker.document}</span>
              </div>
            </div>
            <div className="row">
              <div className="item">
                <strong>{t('Email')}</strong>
                <span>{serviceTaker.email}</span>
              </div>

              <div className="item">
                <strong>{t('Phone')}</strong>
                <span>{serviceTaker.phone}</span>
              </div>
            </div>
          </div>
        </S.DataSection>

        <PackagesAccordion items={budget.items} />

        <footer>
          {isTheCustomerMinor && (
            <caption>
              {t(
                'The facial recognition process must be performed by the legal guardian',
              )}
              {isMobile && `: ${serviceTaker.firstName}`}
            </caption>
          )}

          <Button variant="primary" onClick={onContinue}>
            {isMobile
              ? t('Go to facial recognition')
              : t("Go to {{name}}'s facial recognition", {
                  name: serviceTaker.firstName,
                })}
          </Button>
        </footer>
      </main>
    </S.Container>
  );
};

export default BudgetSummary;
